import { useRef, useState } from 'react';
import type { PluginViewState } from './PluginView';

export type PluginViewLoadingState = {
  loading: boolean;
  isSecondLoad: boolean;
};

export const usePluginViewLoading = ({
  page,
  pending,
  frameLoaded,
}: PluginViewState): PluginViewLoadingState => {
  const hasStartedLoading = useRef(false);
  const [hasLoaded, setHasLoaded] = useState(false);

  if (!hasStartedLoading.current && pending) {
    hasStartedLoading.current = true;
  }

  if (!hasLoaded && !pending && hasStartedLoading.current) {
    setHasLoaded(true);
  }

  const frameLoading = page?.type === 'iframe' && !frameLoaded;

  return {
    loading: pending || frameLoading || (page?.type === 'script' && !hasLoaded),
    isSecondLoad: hasLoaded && pending,
  };
};
